class Projeto {
      id: Number = 0;
      nome: string = "";
      d_E_L_E_T_E: boolean = false;
      criadoEm: Date = new Date();
      excluidoEm: Date | null = null;
}
export default Projeto;

